// extracted by mini-css-extract-plugin
export default {"tab":"EntityMain_tab__snkf6","tabContent":"EntityMain_tabContent__19ghW"};